/**
 * @desc updateCabinStatus
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  body: Array<defs.wms.AllocationUpdateCabinStatusRequestDto>,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocation/updateCabinStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
